module.exports = __webpack_public_path__ + "img/Path 517.dc10ea05.png";